import { useEffect, useRef, useState } from 'react';
import './PayoutTable.css';

const PayoutTable = () => {
  const [isVisible, setIsVisible] = useState(false);
  const tableRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (tableRef.current) {
      observer.observe(tableRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="payout-table" ref={tableRef}>
      <div className="payout-table__graph">
        <div className="payout-table__header">
          <span>FTD Conversion Level</span>
          <span>Payout</span>
        </div>
        <div className="payout-table__row">
          <div className="payout-table__bar-container">
            <div className={`payout-table__bar-fill ${isVisible ? 'animate' : ''}`} style={{'--target-width': '50%'}}>
              <span>100 or more</span>
            </div>
            <span className="payout-table__payout">50%</span>
          </div>
        </div>
        <div className="payout-table__row">
          <div className="payout-table__bar-container">
            <div className={`payout-table__bar-fill ${isVisible ? 'animate' : ''}`} style={{'--target-width': '40%'}}>
              <span>71 - 100</span>
            </div>
            <span className="payout-table__payout">40%</span>
          </div>
        </div>
        <div className="payout-table__row">
          <div className="payout-table__bar-container">
            <div className={`payout-table__bar-fill ${isVisible ? 'animate' : ''}`} style={{'--target-width': '35%'}}>
              <span>36 - 70</span>
            </div>
            <span className="payout-table__payout">35%</span>
          </div>
        </div>
        <div className="payout-table__row">
          <div className="payout-table__bar-container">
            <div className={`payout-table__bar-fill ${isVisible ? 'animate' : ''}`} style={{'--target-width': '25%'}}>
              <span>1 - 35</span>
            </div>
            <span className="payout-table__payout">25%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayoutTable;
